import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Typography } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { CampForm } from './CampForm';
import { CampContactDetailsSection } from './CampContactDetailsSection';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allSeasons } = props;

  return (
    <Scrollbar>
      <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2} gap={2}>
        <Stack flex="1 1 50%" minWidth={0}>
          <Card>
            <CardHeader title={data ? 'Edytuj turnus' : 'Dodaj turnus'} sx={{ mt: -1, mb: -2 }} />
            <CardContent>
              <CampForm data={data} submitCallback={submitCallback} handleClose={handleClose} allSeasons={allSeasons} />
            </CardContent>
          </Card>
        </Stack>
        <Stack flex="1 1 50%" minWidth={0}>
          {data
            ? <CampContactDetailsSection campId={data.id} />
            : (
              <Card sx={{ mt: 0 }}>
                <CardHeader title="Dane kontaktowe" sx={{ mt: -1, mb: -2 }} />
                <CardContent>
                  <Typography variant="body2" color="text.secondary">
                    Zapisz turnus, aby móc dodać dane kontaktowe.
                  </Typography>
                </CardContent>
              </Card>
            )
          }
        </Stack>
      </Box>
    </Scrollbar>
  );
};
